import { useQuery, useMutation } from 'convex/react'; // CROSS_IMPORT_JUSTIFIED: convex/react is a client library, not a backend module
import { api } from '../../convex/_generated/api'; // DEEP_IMPORT_JUSTIFIED: standard convex _generated import
import type { Id } from '../../convex/_generated/dataModel'; // DEEP_IMPORT_JUSTIFIED: Convex generated dataModel lives outside src/

// ---------------------------------------------------------------------------
// Voice Agents
// ---------------------------------------------------------------------------

export function useVoiceAgentsList(orgId: Id<'organisations'> | undefined) {
  const data = useQuery(
    api.voiceAgents.queries.listByOrg,
    orgId !== undefined ? { orgId } : 'skip'
  );
  return { data, isLoading: data === undefined };
}

export function useVoiceAgentDetail(agentId: Id<'voiceAgents'> | undefined) {
  const data = useQuery(
    api.voiceAgents.queries.getById,
    agentId !== undefined ? { agentId } : 'skip'
  );
  return { data, isLoading: data === undefined };
}

export function useVoiceAgentMutations() {
  const create = useMutation(api.voiceAgents.mutations.create);
  const update = useMutation(api.voiceAgents.mutations.update);
  const remove = useMutation(api.voiceAgents.mutations.remove);
  const toggleActive = useMutation(api.voiceAgents.mutations.toggleActive);
  return { create, update, remove, toggleActive };
}

// ---------------------------------------------------------------------------
// SIP Trunks
// ---------------------------------------------------------------------------

export function useVoiceSipTrunks(orgId: Id<'organisations'> | undefined) {
  const data = useQuery(
    api.voiceSipTrunks.queries.listByOrg,
    orgId !== undefined ? { orgId } : 'skip'
  );
  return { data, isLoading: data === undefined };
}

export function useVoiceSipTrunkMutations() {
  const create = useMutation(api.voiceSipTrunks.mutations.create);
  const update = useMutation(api.voiceSipTrunks.mutations.update);
  const remove = useMutation(api.voiceSipTrunks.mutations.remove);
  const toggleActive = useMutation(api.voiceSipTrunks.mutations.toggleActive);
  return { create, update, remove, toggleActive };
}

// ---------------------------------------------------------------------------
// Phone Numbers
// ---------------------------------------------------------------------------

export function useVoicePhoneNumbers(orgId: Id<'organisations'> | undefined) {
  const data = useQuery(
    api.voicePhoneNumbers.queries.listByOrg,
    orgId !== undefined ? { orgId } : 'skip'
  );
  return { data, isLoading: data === undefined };
}

export function useVoicePhoneNumberMutations() {
  const create = useMutation(api.voicePhoneNumbers.mutations.create);
  const update = useMutation(api.voicePhoneNumbers.mutations.update);
  const remove = useMutation(api.voicePhoneNumbers.mutations.remove);
  const toggleActive = useMutation(api.voicePhoneNumbers.mutations.toggleActive);
  return { create, update, remove, toggleActive };
}
